import { ReactElement } from "react";
import { IDataSource } from "../../../../services/http/datasource/models/IDataSource"
import { DataSource } from "../../../../services/http/datasource/models/DataSource"
import Signal from "./Signal";
import Battery from "./Battery";
import IndicatorNumber from "../../IndicatorNumber";

const SensorIcon = (): ReactElement =>
{
    function loadDataSourceMock(): IDataSource
    {
        const dataElement = new DataSource();
        dataElement.unitOfMeasureCode = "ºF";

        return dataElement;
    }

    const dataSource = loadDataSourceMock();

    return (
        <div>
            <Signal value={50} />
            <Battery value={50} />
            <IndicatorNumber label="Last value" unitOfMeasure={dataSource.unitOfMeasureCode} value={0} />
        </div>
    );
}

export default SensorIcon;